import { removeParamsFromQuery } from '@marketplace-web/shared/url-util'

export const removeLocaleUrlParam = (relativeUrl: string, urlQuery: string) =>
  removeParamsFromQuery(relativeUrl, urlQuery, ['locale'])
